  let targetDate = 0;
  let saleText = '';
  let dateText = '';
  //let date_days = 0;
  let date_hour = 2;
  let date_min = 59;
  let date_sec = 59;
  dateObj = { 
    //days: date_days,
    hours: date_hour,
    minutes: date_min,
    seconds: date_sec 
  }
  const additionalTime2 = addTimeToDateWithMilliseconds2(new Date(), dateObj)
  const timer = setInterval(updateCountdown2, 1000);
  function updateCountdown2() {
    const now = new Date().getTime();
    targetDate = additionalTime2.getTime();
    if(targetDate > 0) {
      
    } else {
      document.querySelector(".timer-vanity").classList.add('d-none');
    }
    const distance = targetDate - now;
    
    // Calculate days, hours, minutes, and seconds
    //const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    //const dayElem = document.querySelector(".timer-day");
    const hrElem = document.querySelector(".timer-hr");
    const minElem = document.querySelector(".timer-min");
    const secElem = document.querySelector(".timer-sec");

    // Display the countdown
    //if(dayElem) dayElem.querySelector("span").innerText = days < 10 ? "0" + days+'d' : days+'d';
    //dayElem.querySelector("p").innerText = days < 2 ? "Day" : "Days";
    if(hrElem) hrElem.querySelector("span").innerText = hours < 10 ? "0" + hours+'h' : hours+'h';
    //hrElem.querySelector("p").innerText = hours < 2 ? "Hour" : "Hours";
    if(minElem) minElem.querySelector("span").innerText = minutes < 10 ? "0" + minutes+'m' : minutes+'m';
    //minElem.querySelector("p").innerText = minutes < 2 ? "Minute" : "Minutes";
    if(secElem) secElem.querySelector("span").innerText = seconds < 10 ? "0" + seconds+'s' : seconds+'s';
    //secElem.querySelector("p").innerText = minutes < 2 ? "Second" : "Seconds";

    // If the countdown is finished, display a message
    if (distance <= 0) {
        clearInterval(timer);
        if(dayElem) dayElem.querySelector("span").innerText = "0";
        if(hrElem) hrElem.querySelector("span").innerText = "00";
        if(minElem) minElem.querySelector("span").innerText = "00";
        if(secElem) secElem.querySelector("span").innerText = "00";
    }
  }
  function addTimeToDateWithMilliseconds2(date, { days = 0, hours = 0, minutes = 0, seconds = 0 }) {
    const milliseconds =
      (days * 24 * 60 * 60 * 1000) +
      (hours * 60 * 60 * 1000) +
      (minutes * 60 * 1000) +
      (seconds * 1000);
    return new Date(date.getTime() + milliseconds);
  }
  
  // Update the countdown every second